import { FaClasses } from "@cervval.js/client-html5-core/src/tools/css.tools";
import { AcceptedHtmlElementContent } from "@cervval.js/client-html5-core/src/tools/dom.tools";
import { ValueOrFunction } from "@cervval.js/common/src/tools/object.tools";
import { ButtonOptions } from "../button/button";
import { IconFaOptions } from "../icon/iconFa";
import { getIconFaName } from "../icon/iconFa.tools";
import { IconFA6 } from "../icon/tools/fontAwesome6IconList.tools";
import { i18n } from "./i18n/i18n";

/** Display configuration */
export interface EmptyStateDisplayConfig {
    /** Icon options to display */
    iconOptions?: IconFaOptions;
    /** Empty state title */
    title: ValueOrFunction<AcceptedHtmlElementContent>;
    /** Empty state description */
    description: ValueOrFunction<AcceptedHtmlElementContent>;
    /** List of action buttons to display in the empty state component */
    actionButtons?: {
        options: ButtonOptions,
        /**
         * Event handler used to bind the callback to the button
         * Make sure your this context is correctly bound
         */
        onClick: EventListenerObject
    }[];
}

/** Enum of EmptyState Pre configurations */
export enum EmptyStateDisplayPreConfig {
    NO_DATA = 1,
    NO_RESULT_IN_FILTER
}

/** Empty state component options */
export interface EmptyStateDisplayOptions extends Partial<EmptyStateDisplayConfig> {
    /** Pre config to use if given */
    preConfig?: EmptyStateDisplayPreConfig;
}


export const EMPTY_STATE_PRE_CONFIGS: { [K in EmptyStateDisplayPreConfig]: EmptyStateDisplayConfig } = {
    [EmptyStateDisplayPreConfig.NO_DATA]: {
        iconOptions: {
            name: getIconFaName(IconFA6.FOLDER_OPEN),
            prefix: FaClasses.REGULAR
        },
        title: () => i18n().preConfig.noData.title,
        description: () => i18n().preConfig.noData.description
    },
    [EmptyStateDisplayPreConfig.NO_RESULT_IN_FILTER]: {
        iconOptions: {
            name: getIconFaName(IconFA6.FILTER_SLASH),
            prefix: FaClasses.REGULAR
        },
        title: () => i18n().preConfig.noResultInFilter.title,
        description: () => i18n().preConfig.noResultInFilter.description
    }
};
